import React from 'react';
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  CircularProgress,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ModalLayout = ({
  open,
  headerText,
  leftButtonText,
  rightButtonText,
  leftButtonProps,
  rightButtonProps,
  onClose,
  onLeftButtonClick,
  onRightButtonClick,
  modalProps,
  headerProps,
  footerProps,
  children,
  size,
  displayFooter,
  disableLeftButton,
  disableRightButton,
  showProgress,
}) => {
  const { t } = useTranslation();
  const renderButton = (text, buttonProps, onClick, disabled, showProgress) => {
    return (
      <Button
        m={0}
        ml={1}
        borderRadius={0}
        bg="brand.60"
        color="brand.60"
        onClick={onClick}
        isDisabled={disabled}
        {...buttonProps}
      >
        {showProgress === false && (text && text.i18nKey ? t(text.i18nKey) : text)}
        {showProgress === true && <CircularProgress mx={4} isIndeterminate size={25} />}
      </Button>
    );
  };

  return (
    <Modal size={size} isOpen={open} onClose={onClose} {...modalProps}>
      <ModalOverlay />
      <ModalContent borderRadius={0}>
        <ModalHeader borderBottom="solid 1px" borderColor="brand.110" {...headerProps}>
          {headerText && headerText.i18nKey ? t(headerText.i18nKey) : headerText}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        {displayFooter && (
          <ModalFooter borderTop="solid 1px" borderColor="brand.110" {...footerProps}>
            <Flex w="100%" alignItems="center" justifyContent="flex-end">
              {!!leftButtonText &&
                renderButton(
                  leftButtonText,
                  leftButtonProps,
                  onLeftButtonClick,
                  disableLeftButton,
                  false
                )}
              {!!rightButtonText &&
                renderButton(
                  rightButtonText,
                  rightButtonProps,
                  onRightButtonClick,
                  disableRightButton,
                  showProgress
                )}
            </Flex>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

ModalLayout.propTypes = {
  open: PropTypes.bool,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  leftButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rightButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  leftButtonProps: PropTypes.object,
  rightButtonProps: PropTypes.object,
  onClose: PropTypes.func,
  onLeftButtonClick: PropTypes.func,
  onRightButtonClick: PropTypes.func,
  children: PropTypes.any,
  modalProps: PropTypes.object,
  headerProps: PropTypes.object,
  footerProps: PropTypes.object,
  size: PropTypes.string,
  displayFooter: PropTypes.bool,
  disableLeftButton: PropTypes.bool,
  disableRightButton: PropTypes.bool,
  showProgress: PropTypes.bool,
};

ModalLayout.defaultProps = {
  headerText: 'empty',
  leftButtonText: 'empty',
  rightButtonText: 'empty',
  open: false,
  leftButtonProps: {},
  rightButtonProps: {},
  onLeftButtonClick: () => {},
  onRightButtonClick: () => {},
  modalProps: {},
  headerProps: {},
  footerProps: {},
  size: 'md',
  displayFooter: true,
  disableLeftButton: false,
  disableRightButton: false,
  showProgress: false,
};

export default ModalLayout;
